import { CONFIG_CATALOG } from "@krea/shared/config/catalog";
import type { AppEnvironment } from "@krea/shared/config/environment";
import type { CountryCode, EnvironmentEnum } from "@krea/shared/types/common";

export const getAppUrls = (
  countryCode: CountryCode,
  environment: EnvironmentEnum,
) => {
  const { customer, lender, partner, admin } =
    CONFIG_CATALOG[environment as AppEnvironment].apps[countryCode];

  return { customer, lender, partner, admin };
};
